export const STEP_SECTION_COPY = {
  NO_STEPS_CREATED: 'No steps created yet, add one to get started',
  NO_STEPS_FOUND: 'No results found',
  STEP_NAME_LABEL: 'Step name',
  STEP_NAME_PLACEHOLDER: 'e.g. Collect user information',
  STEP_NAME_UNIQUE_ERROR: 'Step name must be unique',
  STEP_NAME_REQUIRED_ERROR: 'Please provide a step name',
  SEARCH_PLACEHOLDER: 'Search...',
  ADD_STEP_BUTTON_TEXT: 'Add step',
  CANCEL_BUTTON_TEXT: 'Cancel',
  ADD_STEP_SUBTITLE:
    'A new step will be added to your flow, along with a transition function linking to the new step.',
  ADD_STEP_TITLE: 'Add step',
  BACK_BUTTON_TEXT: 'Back',
  modal: {
    confirm: 'Connect',
  },
} as const;
